import React, { FC, useEffect, useState } from 'react';
import axios from 'axios';
import { Assessment } from '../interfaces';
import { HeadingOne } from 'hui';
import { doeApiUrl } from '../../../api';
import { TableLayout } from './Table/TableLayout';
import { FilterLayout, generateFilterUrl } from './Filter/FilterLayout';
import { HeaderZone } from './style';

export const AssessmentsPage: FC<{}> = () => {
  const [dataSource, setDataSource] = useState<Assessment[]>([]);

  useEffect(() => {
    axios.get<Assessment[]>(`${doeApiUrl}assessments`).then(({ data }) => {
      setDataSource(data);
    });
  }, []);

  const filterAssessments = () => ({ region, ASO }): void => {
    axios
      .get<Assessment[]>(`${doeApiUrl}assessments${generateFilterUrl(region, ASO)}`)
      .then(({ data }) => {
        setDataSource(data);
      });
  };

  return (
    <>
      <HeaderZone>
        <HeadingOne>Assessment Picker</HeadingOne>
      </HeaderZone>
      <FilterLayout onFilter={filterAssessments} />
      <TableLayout dataSource={dataSource} />
    </>
  );
};
